export default __webpack_public_path__ + "static/media/imDigitalLogo.8654858e.png";